import { StyledSvg } from "baseui/icon";
import React from "react";

export const PlayIcon = (props: React.ComponentProps<typeof StyledSvg>) => (
  <StyledSvg viewBox="0 0 16 16" {...props}>
    <path d="M3.7985 1.37029C3.03441 1.40052 2.33301 2.0239 2.33301 2.86378V13.1359C2.33301 14.2557 3.58059 14.9905 4.56022 14.4478L13.8298 9.31169C14.8376 8.75326 14.8376 7.24642 13.8298 6.68799L4.56022 1.55193C4.31531 1.41625 4.0532 1.36021 3.7985 1.37029Z" />
  </StyledSvg>
);

export const PlayIconWithActiveBackground = (props: React.ComponentProps<typeof StyledSvg>) => (
  <svg width="47" height="40" viewBox="0 0 47 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0.166992 6.6665C0.166992 2.9847 3.15169 0 6.8335 0H40.166C43.8478 0 46.8325 2.9847 46.8325 6.6665V33.3325C46.8325 37.0143 43.8478 39.999 40.166 39.999H6.8335C3.15169 39.999 0.166992 37.0143 0.166992 33.3325V6.6665Z"
      fill="#C0C0C0"
      fillOpacity="0.77"
    />
    <path
      d="M17.3592 10.0015C16.216 10.0471 15.1665 10.9872 15.1665 12.2538V27.7455C15.1665 29.4343 17.0332 30.5424 18.499 29.7239L32.3684 21.9781C33.8764 21.1359 33.8764 18.8634 32.3684 18.0212L18.499 10.2754C18.1325 10.0708 17.7403 9.98629 17.3592 10.0015Z"
      fill="black"
      fillOpacity="0.67"
    />
  </svg>
);

export const PlayOutlineIcon = (props: React.ComponentProps<typeof StyledSvg>) => (
  <StyledSvg viewBox="0 0 18 18" {...props}>
    <path
      fill="currentColor"
      d="M4.27368 1.54176C3.41408 1.57576 2.625 2.27707 2.625 3.22193V14.7781C2.625 16.0379 4.02853 16.8645 5.13062 16.2539L15.5588 10.4758C16.6926 9.8476 16.6926 8.15241 15.5588 7.52418L5.13062 1.7461C4.85509 1.59346 4.56022 1.53042 4.27368 1.54176ZM4.28687 2.64991C4.38384 2.64949 4.48548 2.67463 4.58496 2.72974L15.0139 8.50782C15.4259 8.73609 15.4259 9.26393 15.0139 9.49219L4.58496 15.2703C4.18704 15.4907 3.75 15.2328 3.75 14.7781V3.22193C3.75 2.99459 3.85902 2.81686 4.01807 2.72315C4.09759 2.6763 4.18989 2.65033 4.28687 2.64991Z"
    />
  </StyledSvg>
);
